import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "submitButton"]

  connect() {
    this.updateSelectedCount()
  }

  toggle() {
    this.updateSelectedCount()
  }

  toggleAll() {
    const allChecked = this.checkboxTargets.every(cb => cb.checked)
    this.checkboxTargets.forEach(cb => cb.checked = !allChecked)
    this.updateSelectedCount()
  }

  clearAll() {
    this.checkboxTargets.forEach(cb => cb.checked = false)
    this.updateSelectedCount()
  }

  selectByIds(event) {
    const ids = JSON.parse(event.currentTarget.dataset.contactIds)
    ids.forEach(id => {
      const label = this.element.querySelector(`label[data-contact-id="${id}"]`)
      if (label) {
        const checkbox = label.querySelector('input[type="checkbox"]')
        if (checkbox) checkbox.checked = true
      }
    })
    this.updateSelectedCount()
  }

  updateSelectedCount() {
    const checked = this.checkboxTargets.filter(cb => cb.checked).length
    if (this.hasSubmitButtonTarget) {
      if (checked > 0) {
        this.submitButtonTarget.value = `Add ${checked} Guest${checked > 1 ? 's' : ''}`
      } else {
        this.submitButtonTarget.value = 'Add Selected Guests'
      }
    }
  }
}
